const TYPE_OPTIONS = [
  { value: 'acquisition', label: 'Acquisition', color: '#3B82F6' },
  { value: 'development', label: 'Development', color: '#2ECC71' },
  { value: 'lending',     label: 'Lending',     color: '#D4AF37' },
]

const STATUS_OPTIONS = ['open', 'won', 'lost', 'deleted']

const S = {
  panel: {
    width: 196, flexShrink: 0, display: 'flex', flexDirection: 'column',
    background: '#061020',
    borderRight: '1px solid rgba(255,255,255,0.07)',
    overflowY: 'auto',
  },
  sectionHeader: {
    padding: '8px 12px',
    borderBottom: '1px solid rgba(255,255,255,0.07)',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  },
  label: {
    fontSize: 9, fontWeight: 600, color: '#94A3B8', letterSpacing: '0.12em',
    textTransform: 'uppercase',
  },
  section: {
    padding: '8px 0',
    borderBottom: '1px solid rgba(255,255,255,0.05)',
  },
  sectionTitle: {
    fontSize: 9, fontWeight: 600, color: '#94A3B8', letterSpacing: '0.12em',
    textTransform: 'uppercase', padding: '0 12px 6px',
  },
  row: {
    display: 'flex', alignItems: 'center', gap: 8,
    padding: '5px 12px', cursor: 'pointer',
    transition: 'background 0.1s',
  },
  rowText: { fontSize: 12, color: '#FFFFFF', letterSpacing: '0.02em' },
  dot: (color) => ({
    width: 7, height: 7, borderRadius: '50%', background: color,
    border: '1px solid rgba(255,255,255,0.3)', flexShrink: 0,
  }),
  checkbox: {
    width: 13, height: 13, accentColor: '#D4AF37', cursor: 'pointer', flexShrink: 0,
  },
  clearBtn: {
    fontSize: 10, color: '#D4AF37', background: 'none', border: 'none',
    cursor: 'pointer', letterSpacing: '0.05em', padding: 0,
  },
  emptyNote: {
    fontSize: 10, color: '#94A3B8', padding: '2px 12px',
    fontStyle: 'italic', opacity: 0.7,
  },
}

export default function FilterPanel({ deals, filters, onFiltersChange }) {
  const allStates = [...new Set(deals.map(d => d.state).filter(Boolean))].sort()

  function toggleType(val) {
    const cur = filters.types
    onFiltersChange({ ...filters, types: cur.includes(val) ? cur.filter(t => t !== val) : [...cur, val] })
  }
  function toggleStatus(val) {
    const cur = filters.statuses
    onFiltersChange({ ...filters, statuses: cur.includes(val) ? cur.filter(s => s !== val) : [...cur, val] })
  }
  function toggleState(val) {
    const cur = filters.states
    onFiltersChange({ ...filters, states: cur.includes(val) ? cur.filter(s => s !== val) : [...cur, val] })
  }
  function setDateRange(val) {
    onFiltersChange({ ...filters, dateRange: val })
  }
  function clearAll() {
    onFiltersChange({ types: ['acquisition', 'development', 'lending'], statuses: [], states: [], search: '', dateRange: 'all' })
  }

  const activeCount = (
    (filters.types.length < 3 ? 1 : 0) +
    (filters.statuses.length > 0 ? 1 : 0) +
    (filters.states.length > 0 ? 1 : 0) +
    (filters.search ? 1 : 0) +
    (filters.dateRange && filters.dateRange !== 'all' ? 1 : 0)
  )

  return (
    <aside style={S.panel}>
      {/* Header */}
      <div style={S.sectionHeader}>
        <span style={S.label}>Filters</span>
        {activeCount > 0 && (
          <button style={S.clearBtn} onClick={clearAll}>Clear all</button>
        )}
      </div>

      {/* Deal Type */}
      <div style={S.section}>
        <div style={S.sectionTitle}>Deal Type</div>
        {TYPE_OPTIONS.map(opt => (
          <label key={opt.value} style={{ ...S.row, opacity: filters.types.includes(opt.value) ? 1 : 0.45 }}>
            <input
              type="checkbox"
              style={S.checkbox}
              checked={filters.types.includes(opt.value)}
              onChange={() => toggleType(opt.value)}
            />
            <div style={S.dot(opt.color)} />
            <span style={S.rowText}>{opt.label}</span>
          </label>
        ))}
      </div>

      {/* Date Sourced */}
      <div style={S.section}>
        <div style={S.sectionTitle}>Date Sourced</div>
        <select
          value={filters.dateRange || 'all'}
          onChange={e => setDateRange(e.target.value)}
          style={{
            width: '100%', boxSizing: 'border-box',
            padding: '6px 8px', fontSize: 12,
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 4, color: '#FFFFFF', outline: 'none',
            // Tells the browser to use dark-mode chrome for the native popup.
            colorScheme: 'dark',
          }}
        >
          {/* Native <option> ignores parent styles on most browsers — set bg+color inline. */}
          <option value="all" style={{ background: '#061020', color: '#FFFFFF' }}>All time</option>
          <option value="7d"  style={{ background: '#061020', color: '#FFFFFF' }}>Last 7 days</option>
          <option value="30d" style={{ background: '#061020', color: '#FFFFFF' }}>Last 30 days</option>
          <option value="90d" style={{ background: '#061020', color: '#FFFFFF' }}>Last 90 days</option>
          <option value="ytd" style={{ background: '#061020', color: '#FFFFFF' }}>Year to date</option>
        </select>
      </div>

      {/* Status */}
      <div style={S.section}>
        <div style={S.sectionTitle}>Status</div>
        {STATUS_OPTIONS.map(s => (
          <label key={s} style={{
            ...S.row,
            opacity: filters.statuses.length === 0 || filters.statuses.includes(s) ? 1 : 0.45,
          }}>
            <input
              type="checkbox"
              style={S.checkbox}
              checked={filters.statuses.includes(s)}
              onChange={() => toggleStatus(s)}
            />
            <span style={S.rowText}>{s.charAt(0).toUpperCase() + s.slice(1)}</span>
          </label>
        ))}
        {filters.statuses.length === 0 && (
          <div style={S.emptyNote}>All statuses</div>
        )}
      </div>

      {/* State */}
      <div style={{ ...S.section, flex: 1, borderBottom: 'none' }}>
        <div style={S.sectionTitle}>
          State
          {filters.states.length > 0 && (
            <span style={{ color: '#D4AF37', marginLeft: 6, fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>
              ({filters.states.length})
            </span>
          )}
        </div>
        <div style={{ maxHeight: 280, overflowY: 'auto' }}>
          {allStates.map(s => (
            <label key={s} style={{
              ...S.row,
              opacity: filters.states.length === 0 || filters.states.includes(s) ? 1 : 0.4,
            }}>
              <input
                type="checkbox"
                style={S.checkbox}
                checked={filters.states.includes(s)}
                onChange={() => toggleState(s)}
              />
              <span style={S.rowText}>{s}</span>
            </label>
          ))}
        </div>
        {filters.states.length === 0 && (
          <div style={S.emptyNote}>All states</div>
        )}
      </div>
    </aside>
  )
}
